import type { TFunction } from 'i18next'

import type { MassRecipientsLabels } from './mass-recipients'

export type MassRecipientsChannelNs = 'massSms' | 'massEmail'

/** The channel's `summary`/`removed` i18n tree → the bar's label set. Shared
 *  by the mass composer dialogs and the single-shipment composers. */
export function buildMassRecipientsLabels(
  t: TFunction,
  ns: MassRecipientsChannelNs,
  counts: { totalSelected: number; willReceive: number; removedCount: number },
): MassRecipientsLabels {
  return {
    sending: t(`${ns}.summary.sending`, {
      willReceive: counts.willReceive,
      total: counts.totalSelected,
    }),
    viewRemoved: t(`${ns}.summary.viewRemoved`, {
      count: counts.removedCount,
    }),
    heading: t(`${ns}.removed.heading`, { count: counts.removedCount }),
    chip: (reason, count) => t(`${ns}.removed.chip.${reason}`, { count }),
    reason: (item) =>
      item.detail
        ? `${t(`${ns}.removed.reason.${item.reason}`)} · ${item.detail}`
        : t(`${ns}.removed.reason.${item.reason}`),
  }
}
